<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'LEAD_INTEGRATIONS.FACEBOOK.INTEGRATION_CONNECTOR.STEPPER_TITLE' | translate }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'INTEGRATIONS.TITLE' | translate"
        [previousPageUrl]="'/app-integrations'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'wide'">
    <h1>
      {{ 'LEAD_INTEGRATIONS.FACEBOOK.INTEGRATION_CONNECTOR.STEPPER_TITLE' | translate }}
    </h1>
    <mat-horizontal-stepper linear labelPosition="bottom" #stepper>
      <mat-step
        [hasError]="(subscribedToPage$ | async) === false"
        [errorMessage]="'LEAD_INTEGRATIONS.FACEBOOK.SUBSCRIBE_ERROR' | translate"
      >
        <ng-template matStepLabel>
          {{ 'LEAD_INTEGRATIONS.FACEBOOK.INTEGRATION_CONNECTOR.PAGE_PICKER_STEP_TITLE' | translate }}
        </ng-template>
        <app-facebook-page-picker (selectedPage)="updateSelectedPage($event)"></app-facebook-page-picker>
        <button
          mat-button
          mat-raised-button
          color="primary"
          class="float-right page-picker-buttons"
          [disabled]="(selectedPage$ | async) === ''"
          (click)="connectSelectedPage()"
          *ngIf="(isConnectingToPage$ | async) === false; else loadingIndicator"
        >
          {{ 'LEAD_INTEGRATIONS.FACEBOOK.INTEGRATION_CONNECTOR.NEXT_BUTTON' | translate }}
        </button>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>
          {{ 'LEAD_INTEGRATIONS.FACEBOOK.INTEGRATION_CONNECTOR.FACEBOOK_FORMS_TABLE_TITLE' | translate }}
        </ng-template>
        <app-facebook-forms-table [facebookPageID$]="selectedPage$"></app-facebook-forms-table>
        <div class="float-right button-container">
          <button
            class="settings-step-buttons"
            mat-button
            color="primary"
            (click)="undoChangesFromStep1()"
            *ngIf="(isDisconnectingPage$ | async) === false; else loadingIndicator"
          >
            {{ 'LEAD_INTEGRATIONS.FACEBOOK.INTEGRATION_CONNECTOR.BACK_BUTTON' | translate }}
          </button>
          <button
            class="settings-step-buttons"
            mat-button
            mat-raised-button
            color="primary"
            (click)="subscribeToForms()"
            [disabled]="(noFormsSelected$ | async) || (isDisconnectingPage$ | async)"
            *ngIf="(isSavingFormsConfig$ | async) === false; else loadingIndicator"
          >
            {{ 'LEAD_INTEGRATIONS.FACEBOOK.INTEGRATION_CONNECTOR.NEXT_BUTTON' | translate }}
          </button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>
          {{ 'LEAD_INTEGRATIONS.FACEBOOK.INTEGRATION_CONNECTOR.DUPE_SETTINGS_STEP_TITLE' | translate }}
        </ng-template>
        <app-facebook-settings (selectedSettings)="updateDupeCriteria($event)"></app-facebook-settings>
        <div class="float-right button-container">
          <button class="settings-step-buttons" mat-button color="primary" matStepperPrevious>
            {{ 'LEAD_INTEGRATIONS.FACEBOOK.INTEGRATION_CONNECTOR.BACK_BUTTON' | translate }}
          </button>
          <button class="settings-step-buttons" mat-button mat-raised-button color="primary" (click)="saveCriteria()">
            {{ 'LEAD_INTEGRATIONS.FACEBOOK.INTEGRATION_CONNECTOR.FINISH_BUTTON' | translate }}
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #loadingIndicator>
  <mat-spinner class="float-right loading-indicator" diameter="30"></mat-spinner>
</ng-template>
